export default __webpack_public_path__ + "static/media/subcategory_car_4.c169c917.png";